import { getAxiosClient } from "../../axios-client";
import { OfferClientPreRefuseRequestBody, OfferClientPreRefuseResponse } from "./types";
const axiosClient = getAxiosClient();
export const offerClientPreRefuse = async (body: OfferClientPreRefuseRequestBody) => {
    return await axiosClient.ax.post<OfferClientPreRefuseResponse>("/Offers/OfferClientPreRefuse", body);
};
